<div class="flex items-center justify-center dialog-header">
    {{type}} Campaign
    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content">
    <form #eventForm="ngForm" [formGroup]="campaignForm" novalidate>
        <div class="p-fluid p-3 -mt-6">

            <div class="field">
                <label for="eventName" class="requiredValue">Campaign</label>
                <input pInputText formControlName="event_name" placeholder="Campaign Name" />
                <small *ngIf="campaignForm.get('event_name')?.hasError('required') && isSubmitted" class="p-error">
                    Campaign Name is required
                </small>
                <small *ngIf="campaignForm.get('event_name')?.hasError('invalidCampaignName') && isSubmitted" class="p-error">
                    Campaign Name can only contain letters, numbers, hyphens (-), and underscores (_)
                </small>
            </div>

            <div class="field" *ngIf="active === 'email'">
                <label for="subject" class="requiredValue">Subject</label>
                <input pInputText formControlName="subject" placeholder="Enter Email Subject" />
                <small *ngIf="campaignForm.get('subject')?.hasError('required') && isSubmitted" class="p-error">
                    Subject is required
                </small>
            </div>

            <div class="field" *ngIf="active === 'email'">
                <div class="flex items-center justify-between mb-2">
                    <label for="templateId" class="requiredValue">Select Email Template</label>
                    <button type="button" (click)="createEmailTemplate()" 
                        class="text-blue-600 hover:text-blue-800 underline text-sm font-semibold">
                        + Create Email Template
                    </button>
                </div>
                <p-select [options]="emailTemplates" optionLabel="template_name" optionValue="template_id"
                    formControlName="template_id" placeholder="Select Email Template"></p-select>
                <small *ngIf="campaignForm.get('template_id')?.invalid && isSubmitted" class="p-error">
                    Email Template ID is required
                </small>
            </div>

            <div class="field" *ngIf="active === 'whatsapp'">
                <div class="flex items-center justify-between mb-2">
                    <label for="templateId" class="requiredValue">Select WhatsApp Template</label>
                    <button type="button" (click)="createWhatsappTemplate()" 
                        class="text-blue-600 hover:text-blue-800 underline text-sm font-semibold">
                        + Create WhatsApp Template
                    </button>
                </div>
                <p-select [options]="whatsappTemplates" optionLabel="template_name" optionValue="meta_template_id"
                    formControlName="template_id" placeholder="Select WhatsApp Template"></p-select>
                <small *ngIf="campaignForm.get('template_id')?.invalid && isSubmitted" class="p-error">
                    WhatsApp Template ID is required
                </small>
            </div>

            <div class="field" *ngIf="active === 'whatsapp' || active === 'email'">
                <div class="flex items-center justify-between mb-2">
                    <label for="contactGroupId" class="requiredValue">Select Contact Group</label>
                    <button type="button" (click)="createContactGroup()" 
                        class="text-blue-600 hover:text-blue-800 underline text-sm font-semibold">
                        + Create Contact Group
                    </button>
                </div>
                <p-select [options]="contactGroups" optionLabel="name" optionValue="id" appendTo="body"
                    (onChange)="onContactGroupChange($event.value)" formControlName="contact_group_id" 
                    placeholder="Select a Contact Group"></p-select>
                <small *ngIf="campaignForm.get('contact_group_id')?.invalid && isSubmitted" class="p-error">
                    Contact Group ID is required
                </small>
                <div class="mt-2 flex items-center gap-2" *ngIf="campaignForm.get('contact_group_id')?.value">
                    <span>Total Contacts in selected group: <strong>{{maxBatchSize || 'N/A'}}</strong></span>
                    <i *ngIf="loadingBatchSize" class="pi pi-spinner pi-spin text-gray-500"></i>
                </div>
            </div>


            <div class="field" *ngIf="active === 'call'">
                <div class="flex items-center justify-between mb-2">
                    <label for="contactGroupId" class="requiredValue">Select Dialing Group</label>
                    <button type="button" (click)="createDialingGroup()" 
                        class="text-blue-600 hover:text-blue-800 underline text-sm font-semibold">
                        + Create Dialing Group
                    </button>
                </div>
                <p-select [options]="contactGroups" optionLabel="name" optionValue="id" appendTo="body"
                    (onChange)="onContactGroupChange($event.value)" formControlName="contact_group_id"
                    placeholder="Select a Dialing Group"></p-select>
                <small *ngIf="campaignForm.get('contact_group_id')?.invalid && isSubmitted" class="p-error">
                    Dialing Group ID is required
                </small>
            </div>



            <div class="field" *ngIf="active !== 'call' && active !== 'email' && active !== 'whatsapp'">
                <label for="status">Status</label>
                <p-select [options]="statusOptions" appendTo="body" formControlName="status"
                    placeholder="Select Status"></p-select>
                <small *ngIf="campaignForm.get('status')?.invalid && isSubmitted" class="p-error">
                    Status is required
                </small>
            </div>

            <div class="field mt-3" *ngIf="active === 'whatsapp' || active === 'email'">
                <label>Do you want to schedule this campaign?</label>
                <div class="flex items-center mt-2">
                    <p-checkbox inputId="schedule" formControlName="is_schedule" (onChange)="onScheduleChange($event)"
                        [binary]="true" />
                    <label for="schedule" class="ml-2 mt-1 font-semibold text-lg">
                        Schedule Campaign
                    </label>
                </div>
            </div>

            <div class="grid grid-col-1 md:grid-cols-2 gap-4 mt-0" *ngIf="active !== 'call'">



                <div class="field" *ngIf="campaignForm.get('is_schedule')?.value">
                    <label for="scheduleDate">Schedule Date & Time</label>
                    <!-- <p-datepicker appendTo="body" 
                    [style]="{'width': '100%'}"
                    [iconDisplay]="'input'"
                    formControlName="schedule_date" showIcon
                        dateFormat="yy-mm-dd"></p-datepicker> -->
                    <p-datepicker appendTo="body" [style]="{'width': '100%'}" inputId="calendar-12h"
                        formControlName="schedule_date" [showTime]="true" [hourFormat]="'12'" [minDate]="minDate" />
                    <small *ngIf="campaignForm.get('schedule_date')?.hasError('required') && isSubmitted" class="p-error">
                        Schedule Date and Time is required
                    </small>
                    <small *ngIf="campaignForm.get('schedule_date')?.hasError('pastDate') && isSubmitted" class="p-error">
                        Cannot schedule for past date and time
                    </small>
                </div>
            </div>

                <!-- <div class="field" *ngIf="campaignForm.get('is_schedule')?.value">
                    <label for="scheduleTime">Schedule Time</label>
                    <p-datepicker 
                    [style]="{'width': '100%'}"
                    [iconDisplay]="'input'"
                    [showIcon]="true" appendTo="body" formControlName="schedule_time" [timeOnly]="true"
                        hourFormat="24" inputId="templatedisplay">
                        <ng-template #inputicon let-clickCallBack="clickCallBack">
                            <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                        </ng-template>
                    </p-datepicker>
                  
                    <small *ngIf="campaignForm.get('schedule_time')?.invalid && isSubmitted" class="p-error">
                        Schedule Time is required
                    </small>
                </div> -->
        </div>
    </form>

    <div class="mt-2 px-3" *ngIf="active === 'call'">
        Total Contacts in selected group: <strong>{{maxBatchSize || 'N/A'}}</strong>
    </div>



    <!-- Call Campaign specific fields -->
    <div *ngIf="active === 'call'" class="grid grid-cols-1 md:grid-cols-2 gap-4 gap-y-0 px-3">


        <div class="field">
            <label for="no_of_batches">Number of Batches</label>

            <div class="flex items-center gap-2 w-full">
                <p-inputnumber type="number" [style]="{'width':'90%'}" class="w-full"
                    placeholder="Enter number of batches" [disabled]="disabledBatchSizeInput" min="1"
                    [max]="maxBatchSize" [(ngModel)]="selectedNumberOfBatch" />

                <i *ngIf="loadingBatchSize" class="pi pi-spinner pi-spin text-gray-500 text-xl"></i>
            </div>

            <small class="text-gray-500">Max Batches allowed: {{maxBatchSize}}</small>
            <small *ngIf="selectedNumberOfBatch > 0 && selectedNumberOfBatch > maxBatchSize" class="p-error block">
                Number of batches cannot exceed {{maxBatchSize}}
            </small>
        </div>


        <div class="field">
            <label for="batch_delay">Batch Delay (minutes)</label>
            <p-inputNumber [max]="5" [(ngModel)]="selectedBatchDelay" [disabled]="selectedNumberOfBatch <= 0"
                placeholder="Enter batch delay in minutes" min="1" />
            <small class="text-gray-500">Delay between batches in minutes (max 5 minutes)</small>
            <small *ngIf="selectedBatchDelay > 5" class="p-error block">
                Batch delay cannot exceed 5 minutes
            </small>
        </div>

        <div class="field">
            <label for="call_delay">Call Delay (seconds)</label>
            <p-inputNumber [max]="10" [(ngModel)]="selectedCallDelay" placeholder="Enter call delay in seconds"
                min="1" />
            <small class="text-gray-500">Delay between individual calls in seconds (max 10 seconds)</small>
            <small *ngIf="selectedCallDelay > 10" class="p-error block">
                Call delay cannot exceed 10 seconds
            </small>
        </div>

    </div>

    <div *ngIf="active == 'call'">
        <div class="grid grid-col-1 gap-4 mt-0 px-3">

            <div class="field">
                <label>Do you want to schedule this campaign?</label>
                <div class="flex items-center mt-2">
                    <p-checkbox inputId="schedule" [(ngModel)]="isSchedule" [binary]="true" />
                    <label for="schedule" class="ml-2 mt-1 font-semibold text-lg">
                        Schedule Campaign
                    </label>
                </div>
            </div>


            <div class="grid grid-col-1 md:grid-cols-2 gap-4 mt-0" >



                <div class="field" *ngIf="isSchedule" style="margin-top: 0px !important;">
                    <label for="scheduleDate">Schedule Date & Time</label>
                    <!-- <p-datepicker appendTo="body" 
                    [style]="{'width': '100%'}"
                    [iconDisplay]="'input'"
                    formControlName="schedule_date" showIcon
                        dateFormat="yy-mm-dd"></p-datepicker> -->
                    <p-datepicker #callSchedulePicker appendTo="body" [style]="{'width': '100%'}" inputId="calendar-12h"
                        [(ngModel)]="call_schedule_date_time" [showTime]="true" [hourFormat]="'12'" [minDate]="minDate" 
                        [showOnFocus]="false" [inline]="isSchedule" />
                    <small *ngIf="isSchedule && !call_schedule_date_time && isSubmitted" class="p-error">
                        Schedule Date and Time is required
                    </small>
                    <small *ngIf="isSchedule && call_schedule_date_time && call_schedule_date_time < minDate && isSubmitted" class="p-error">
                        Cannot schedule for past date and time
                    </small>
                </div>


            </div>
        </div>
    </div>

    <div class="flex justify-end gap-2 mt-4">
        <p-button type="button" label="Cancel" variant="outlined" severity="danger" class="mr-2"
            (click)="handleCloseDialog()"></p-button>

        <p-button type="submit" icon="pi pi-save" (onClick)="onSubmit()" [loading]="btnLoading"
            [disabled]="btnLoading || loadingBatchSize" label="Save" class="mr-2"></p-button>
    </div>
</div>